import { handleGetColecction } from '@/constantes/helpers';
import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import pagos from '@/vistas/Reportes2/reportes/pagos';
const db = firebase.firestore();
import axios from 'axios'
import { getJSON } from 'jquery';

const listaTicketsExistentes = [
  2876,
  2800,
  2409,
  2408,
  2395,
  2390,
  2285,
  2265,
  2245,
  2170,
  2045,
  2005,
  1965,
  1861,
  819,
  756,
  735,
  734,
  707,
  690,
  602,
  601,
  522,
  520,
  410,
  325,
  291
];

const store = {
  state: {
    serviciosPropietario: {},
    serviciosPropietarioStatic: {},
    indiceServiciosPropietario:[],
    indiceServiciosPropietarioStatic:[],
    indiceTicketsPropietario:[],
    indiceTicketsPropietarioStatic: [],
    indiceTickets:[],
    indiceTicketsStatic:[],
    indiceTicketsReporte:[],
    indiceTicketsCorte:[],
    ticketActual:{},
    idTicketCount:0,
   
  },
  getters: {
      serviciosPropietario: state => {
        return state.serviciosPropietario;
      },
      serviciosPropietarioStatic: state => {
        return state.serviciosPropietarioStatic;
      },
      indiceTickets: (state,_,rootState) => {
        console.log("stateNuevo", rootState[13].listaServiciosCasos)
        const tickets = state.indiceTickets
        const caso  = rootState[13].listaServiciosCasos

        
      
        console.log("tikects", tickets)
        console.log("state",caso)

        
        if(!caso) return []
        //  const servicios_caso = JSON.parse(JSON.stringify([rootState[13].listaServiciosCasos.servicios_caso]))
        const servicios_caso = caso.servicios_caso
        console.log("caso", servicios_caso)
        

        if(!servicios_caso) return []
        
        if(!tickets) return []
        

        tickets.forEach(e => {

          const pagos = e.pagos_pendientes
          console.log("pagos pendientes", pagos)

          if(!pagos) return

          pagos.forEach((p, i) => {

            const servicio = servicios_caso[p.id_servicio_caso]
            console.log("servicio", servicio)

            if(!servicio) return 

            e[i] = servicio
           console.log("jol")

          })

          
        })
     
        return tickets
        
      },
      indiceTicketsCorte: state => {
        return state.indiceTicketsCorte;
      },
      indiceTicketsReporte: state => {
        return state.indiceTicketsReporte;
      },
      indiceServiciosPropietario: state => {
        return state.indiceServiciosPropietario;
      },
      indiceServiciosPropietarioStatic: state => {
        return state.indiceServiciosPropietarioStatic;
      },
      indiceTicketsPropietario: state => {
        return state.indiceTicketsPropietario;
      },
      indiceTicketsPropietarioStatic: state => {
        return state.indiceTicketsPropietarioStatic;
      },
      indiceTicketsStatic: (state,_,rootState) => {
        console.log("indiceTicketsStatic", rootState[13].listaServiciosCasos)
        const tickets = state.indiceTicketsStatic
        const caso  = rootState[13].listaServiciosCasos

        
      
        console.log("tikects", tickets)
        console.log("state",caso)

        
        if(!caso) return []
        //  const servicios_caso = JSON.parse(JSON.stringify([rootState[13].listaServiciosCasos.servicios_caso]))
        const servicios_caso = caso.servicios_caso
        console.log("caso", servicios_caso)
        

        if(!servicios_caso) return []
        
        if(!tickets) return []
        

        tickets.forEach(e => {

          const pagos = e.pagos_pendientes
          console.log("pagos pendientes", pagos)

          if(!pagos) return

          pagos.forEach((p, i) => {

            const servicio = servicios_caso[p.id_servicio_caso]
            console.log("servicio", servicio)

            if(!servicio) return 

            e[i] = servicio
           console.log("jol")

          })

          
        })
     
        return tickets
        
      },
      ticketActual:state => {
        return state.ticketActual;
      },
      idTicketCount:state => {
        return state.idTicketCount;
      },
  },
  mutations: {
      ASIGNA_SERVICIOS_PROPIETARIO(state, data){
        state.serviciosPropietario = data;
      },
      ASIGNA_SERVICIOS_PROPIETARIO_STATIC(state, data){
        state.serviciosPropietarioStatic = data;
      },
      ASIGNA_INDICE_SERVICIOS_PROPIETARIO(state, data){
        state.indiceServiciosPropietario = data;
      },
      ASIGNA_INDICE_SERVICIOS_PROPIETARIO_STATIC(state, data){
        state.indiceServiciosPropietarioStatic = data;
      },
      ASIGNA_INDICE_TICKETS(state,data){
        state.indiceTickets = data;
      },
      ASIGNA_INDICE_TICKETS_CORTE(state,data){
        state.indiceTicketsCorte = data;
      },
      ASIGNA_INDICE_TICKETS_REPORTE(state,data){
        state.indiceTicketsReporte = data;
      },
      ASIGNA_INDICE_TICKETS_PROPIETARIO(state, data){
        state.indiceTicketsPropietario = data;
      },
      ASIGNA_INDICE_TICKETS_PROPIETARIO_STATIC(state, data){
        state.indiceTicketsPropietarioStatic = data;
      },
      ASIGNA_INDICE_TICKETS_STATIC(state,data){
        state.indiceTicketsStatic = data;
      },
      ASIGNA_TICKET_ACTUAL(state, data){
        state.ticketActual = data;
      },
      ASIGNA_ID_TICKET_COUNT(state,id){
        state.idTicketCount = id;
      }
  },
  actions: {
    restablecerValoresSaldo({commit}){
      commit('ASIGNA_INDICE_TICKETS_PROPIETARIO',[])
      commit('ASIGNA_INDICE_TICKETS',[])
      commit('ASIGNA_INDICE_TICKETS_PROPIETARIO_STATIC',[])
      commit('ASIGNA_INDICE_TICKETS_STATIC',[])
      commit('ASIGNA_INDICE_SERVICIOS_PROPIETARIO', [])
      commit('ASIGNA_SERVICIOS_PROPIETARIO',[])
      commit('ASIGNA_SERVICIOS_PROPIETARIO_STATIC', [])
      commit('ASIGNA_PROPIETARIO', {})
      commit('ASIGNA_PROPIETARIO_ACTUAL', {})
      commit('ASIGNA_PROPIETARIO_TIEMPO_REAL', {})
    },
    actualizarUltimoIdTicket({getters}) {
      return new Promise((resolve) => {
        const franquicia = getters.franquicia;
        const ultimo = getters.franquicia.id_ultimo_ticket+1;
        franquicia.id_ultimo_ticket = ultimo;
        
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .set({id_ultimo_ticket:ultimo},{merge:true}).then(() => {
            resolve(ultimo)
        })
      })

    },
    cargaCatalogoServiciosCasosPorPropietario({ commit,getters }, {anio,id_propietario}) {
      console.log("STORE CARGA SERVICIOS CASOS PROPIETARIO " + anio)
      console.log("STORE CARGA ID PROPIETARIO " + id_propietario);

      return new Promise((resolve) => {
        db.collection(FS_COLLECTIONS.PROPIETARIOS)
        .doc(id_propietario).collection("ServiciosCasos_Propietario").onSnapshot(docs => {

          let servicios = {}
          let servicios_propietario = []

          docs.forEach(doc => {
            if(doc.exists){
              
              servicios = {...servicios,...doc.data()}

              for(let i in doc.data()){
                const item = doc.data()[i]
                item.id_servicio_caso = i;
                servicios_propietario.push(item)
              }

            }
          })

          resolve(servicios)
          commit('ASIGNA_INDICE_SERVICIOS_PROPIETARIO', servicios_propietario)
          commit('ASIGNA_SERVICIOS_PROPIETARIO',servicios)

        })
      })
    },

    cargarServiciosSinTicket({ commit,getters }, id_propietario) {
      //console.log("🚀 ~ file: saldo.js ~ line 250 ~ cargarServiciosSinTicket ~ id_propietario", id_propietario)
      //console.log("🚀 ~ file: saldo.js ~ line 252 ~ cargarServiciosSinTicket ~ getters.franquicia.id", getters.franquicia.id)
      return new Promise((resolve) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection("ServiciosCasos")
        .where("id_propietario", "==", id_propietario)
        .where("servicio_generico.activo", "==", true)
        .get().then(docs => {
  
          let servicios_propietario = []

          docs.forEach(doc => {
            if(doc.exists){
              
              const item = doc.data()
              item.id_servicio_caso = doc.id;
              item.id = doc.id;

              if(!item.no_ticket){
                servicios_propietario.push(item)
              }
              
            }
          })

          resolve(servicios_propietario)
        })
      })
    },

    cargaCatalogoServiciosCasosPorPropietarioStatic({ commit,getters }, {anio,id_propietario}) {
      console.log("STORE CARGA SERVICIOS CASOS PROPIETARIO " + anio)
      console.log("STORE CARGA ID PROPIETARIO " + id_propietario);

      return new Promise((resolve) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection("ServiciosCasos").where("id_propietario", "==", id_propietario).get().then(docs => {

          let servicios = {}
          let servicios_propietario = []
          let total = 0;
          docs.forEach(doc => {
            if(doc.exists){
              
              
              
              const item = doc.data();

              //if(!listaTicketsExistentes.includes(item.no_ticket)){

                if(item.servicio_generico.activo){
                  item.id_servicio_caso = doc.id;
                  item.id = doc.id;
                  servicios_propietario.push(item)
                  
                  servicios[doc.id] = doc.data();
                
                
                  total+= item.servicio_generico.total;
                }
              //}
            }
          })
          // console.log("🚀 ~ file: saldo.js total", total)
          // console.log('servicios_propietario 99', servicios_propietario)
          // console.log('servicios 99', servicios)
          commit('ASIGNA_INDICE_SERVICIOS_PROPIETARIO_STATIC', servicios_propietario)
          commit('ASIGNA_SERVICIOS_PROPIETARIO_STATIC',servicios)
          resolve(servicios)

        })
      })
    },
    cargaIndiceTickets({getters,commit}, {anio,id_propietario}){

      return new Promise(resolve => {

        db.collection(FS_COLLECTIONS.PROPIETARIOS).
        doc(id_propietario).collection("Tickets_Propietario").onSnapshot(docs => {

          const ticketsPropietario = []

          docs.forEach(doc => {
            
            if(doc.exists){

              const ticket = doc.data()
              for(let i in ticket){
                const item = ticket[i];
                item.ticket = i;
                const busqueda = ticketsPropietario.find(x => x.ticket === item.ticket);
                if(!busqueda){
                  ticketsPropietario.push(item);
                }
                
              }

            }

          })
          // console.log("🚀 ~ file: saldo.js ~ line 202 ~ doc ~ ticketsPropietario", ticketsPropietario)

          resolve(ticketsPropietario)
          commit('ASIGNA_INDICE_TICKETS_PROPIETARIO',ticketsPropietario);
          commit('ASIGNA_INDICE_TICKETS',ticketsPropietario)

        })

      })
    },

    async getPagosPendientes({getters,commit, dispatch}, idTicket){
      return new Promise(resolve => {
        const listaServiciosxPropietario = getters.indiceServiciosPropietarioStatic;
        // console.log("🚀 ~ file: saldo.js ~ line 355 ~ getPagosPendientes ~ listaServiciosxPropietario", listaServiciosxPropietario)
        let pagosTotalServicios = 0;
        for(let i in listaServiciosxPropietario){
          let item = listaServiciosxPropietario[i];

          if(item.no_ticket == idTicket && item.servicio_generico.activo){
            pagosTotalServicios+=item.servicio_generico.total;
          }
        }
        resolve(pagosTotalServicios)
      })
    },

    //INICIO CARGA TICKETS DEL PROPIETARIO por marco 27 septiembre 2022 salu2
    cargaIndiceTicketsStatic({getters,commit, dispatch}, {anio,id_propietario}){
      return new Promise(resolve => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.TICKETS).where("id_propietario", "==", id_propietario).get().then(docs => {

          const ticketsPropietario = []

          docs.forEach(async(doc) => {
            if(doc.exists){
              const ticket = doc.data()
              ticket.id = doc.id;
              ticket.ticket = doc.id;

              /* ??marco 
              const busqueda = ticketsPropietario.find(x => x.ticket === ticket.ticket);
              if(!busqueda){ 
              */

                ticket.total_pagos_pendientes = await dispatch('getPagosPendientes', ticket.id_numerico);
                ticketsPropietario.push(ticket);
              //}
              
            }
          })
          // console.log("🚀 ~ file: saldo.js ~ line 202 ~ doc ~ cargaIndiceTicketsStatic", ticketsPropietario)

          
          commit('ASIGNA_INDICE_TICKETS_PROPIETARIO_STATIC',ticketsPropietario);
          commit('ASIGNA_INDICE_TICKETS_STATIC',ticketsPropietario)
          resolve(ticketsPropietario)

        })

      })
    },






    //Inicio del problema de tickets de corte de caja
    cargaIndiceTicketsParaCorteCaja({getters,commit}, {fecha, esGeneral = false}){
      console.log("CARGA TICKETS REPORTE", fecha)

      var listaTickets = [];
      return new Promise((resolve) => {

        const ref = db
        .collection(FS_COLLECTIONS.FRANQUICIAS).
        doc(getters.franquicia.id).
        collection(FS_COLLECTIONS.TICKETS_INDICES)

          if(!esGeneral){
            const docPath = ref.doc(fecha+'')

            docPath.onSnapshot(doc => {

              const ticket = doc.data();
              for(var i in ticket){
                var temp_ticket = ticket[i];
                listaTickets.push(temp_ticket);
              }

              // console.log("🚀 ~ file: saldo.js ~ line 229 ~ returnnewPromise ~ listaTickets", listaTickets)
              commit('ASIGNA_INDICE_TICKETS_CORTE',listaTickets);
              resolve()

            })
          } else {

            ref.onSnapshot(docs => {

              docs.forEach(e => {

                const obj = e.data()

                for(const j in obj) {
                  const item = obj[j]
                  listaTickets.push(item)
                }

              })

              // console.log("🚀 ~ file: saldo.js ~ line 254 ~ returnnewPromise ~ listaTickets", listaTickets)

              commit('ASIGNA_INDICE_TICKETS_CORTE',listaTickets);
              resolve()

            })
              
            

          }
        
        
      });
    },
    cargaIndiceTicketsReporte({getters,commit}, fecha){
      console.log("ARGA TICKETS REPORTE 2",fecha)

      var listaTickets = [];
      return new Promise(async(resolve) => {
        
        // for (var i = fecha.inicio_anio; i <= fecha.fin_anio; i++) {
        //   console.log('fecha.inicio_anio', i)
        //   console.log(i+'')
        //   let docPath = db
        //   .collection(FS_COLLECTIONS.FRANQUICIAS).
        //   doc(getters.franquicia.id).
        //   collection(FS_COLLECTIONS.TICKETS_INDICES).doc(i+'')

        //   docPath.onSnapshot(doc => {
        //     var ticket = doc.data();
        //     for(var i in ticket){
        //         var temp_ticket = ticket[i];
        //         listaTickets.push(temp_ticket);
        //     }
            
        //   })
        // }

        const allIndicesReportes = await db.collection(FS_COLLECTIONS.FRANQUICIAS).
        doc(getters.franquicia.id).collection(FS_COLLECTIONS.TICKETS_INDICES);
        allIndicesReportes.get().then((querySnapshot) => {
            const tempDoc = querySnapshot.docs.map((doc) => {
              var ticket = doc.data();
              console.log("tikec dek sakdi", ticket)
              for(var i in ticket){
                  var temp_ticket = ticket[i];
                  listaTickets.push(temp_ticket);
              }
            })

            
            commit('ASIGNA_INDICE_TICKETS_REPORTE',listaTickets);
            resolve(true)
            console.log("tempDoc",tempDoc)
          })


        
      });
    },
    cargaTicketActual({getters,commit}, id_ticket){
      console.log("STORE ID TICKET" + id_ticket)
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.TICKETS)
        .doc(id_ticket).get()
          .then(doc => {
            console.log("CARGA TICKET DE STORE: ");
            console.log(doc.data())
            commit('ASIGNA_TICKET_ACTUAL', doc.data())
            resolve(doc.data());
          })
          .catch(error => {
            console.error('Error obteniendo ticket: ', error)
            reject(error)
          })
      })
    },
    actualizarTicket({getters,dispatch},ticket){
      //SI EL TICKET FINALIZA
      if(ticket.finalizado){
        //Buscar items que tienen descuento en monedero
        return new Promise((resolve, reject) => {
          console.log("%cEl TICKET HA FINALIZADO",'background: green; color: #fff');
          dispatch('asignarMonederoPropietario',ticket).then(() => {
            console.log("Datos propietario actualizado correctamente")
            db.collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.TICKETS)
            .doc(ticket.numero_ticket)
            .update(ticket).then(() => {
              resolve();
            })
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          db.collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.TICKETS)
            .doc(ticket.numero_ticket)
            .update(ticket).then(() => {
              resolve();
            })
        })
      }
    },
    regresaMonederoAPropietario({getters}, info){
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.PROPIETARIOS).doc(info.id_propietario).get().then(prop => {
          console.log("Info: ", info)
          console.log("Info", prop.data())
          console.log(typeof(prop.data().monedero))
          console.log(typeof(info.monedero))
          if(typeof(prop.data().monedero)=="number" && typeof(info.monedero)=="number" ){
            var monedero = parseInt(prop.data().monedero) + parseInt(info.monedero);
            db.collection(FS_COLLECTIONS.PROPIETARIOS).doc(info.id_propietario).
            set({monedero:monedero},{merge:true}).then(() => {
              resolve()
            }).catch(error => {
              reject(error);
            })
          } else {
            reject({error:"Un dato para actualizar el monedero no es numerico"})
          }

        }).catch(error => {
          reject(error);
        })
      })
    },
    asignarMonederoPropietario({getters},ticket){
      console.log("%cASIGNAR MONEDERO PROPIETARIO",'background: red; color: #bada55');
      let tickets_con_descuento = ticket.pagos_pendientes.filter(ticket => ticket.tiene_descuento!==undefined);
      let tickets_con_monedero = tickets_con_descuento.filter(ticket => ticket.descuento.aplica_monedero);
      console.log("Tickets con monedero")
      console.log(tickets_con_monedero)
      if(tickets_con_monedero.length>0){
        var total_monedero = 0;
        var total = 0;
        for(var i in tickets_con_monedero){
          var cantidad = 0;
          if(tickets_con_monedero[i].descuento.tipo_descuento=="porcentaje"){
            total = tickets_con_monedero[i].descuento.precio * tickets_con_monedero[i].cantidad;
            var porcentaje = (tickets_con_monedero[i].descuento.cantidad/100) * total ;
            cantidad = porcentaje;
            //cantidad = total-porcentaje;
            console.log("Total normal " + total);
            console.log("Total a restar " + porcentaje)
            console.log("Cantidad asignada del porcentaje " + cantidad)
          } else {
            cantidad = tickets_con_monedero[i].cantidad * tickets_con_descuento[i].descuento.cantidad;
            //console.log("Cantidad normal asignada " + cantidad)
          }
          total_monedero+=cantidad;
        }
        console.log("%cTotal monedero " + total_monedero,'background: red; color: #bada55');
        //Actualizar el monedero del propietario
        let docPath = db.collection(FS_COLLECTIONS.PROPIETARIOS).doc(getters.propietarioActual.id);
        docPath.get().then(doc => {
          let nuevo_propietario = doc.data();
          nuevo_propietario.monedero+=+total_monedero
          console.log("Nuevo propietario")
          console.log(nuevo_propietario)
          return new Promise((resolve, reject) => {
            db.collection(FS_COLLECTIONS.PROPIETARIOS)
            .doc(getters.propietarioActual.id)
            .update(nuevo_propietario)
            .then(() => {
              console.log("%cEste propietario se ha actualizado",'background: ; color: #bada55');
              console.log(nuevo_propietario)
                  resolve()
            })
            .catch(error => {
              reject(error)
            })
          })
        })
        //console.log("Cantidad para asignar al monedero: " + total_monedero)
      } else {
        console.log("%cAl parecer este ticket no tiene servicios con monedero",'background: red; color: #bada55');
        return new Promise((resolve, reject) => {
          resolve()
        })
      }
    },
    guardarTicket({getters,dispatch},ticket){
      console.log("GUARDA TICKET")
      console.log(ticket)
      //SI EL TICKET FINALIZA
      if(ticket.finalizado){
        //Buscar items que tienen descuento en monedero
        return new Promise((resolve, reject) => {
          ticket.id_numerico = getters.franquicia.id_ultimo_ticket;
          console.log("%cEl TICKET HA FINALIZADO",'background: green; color: #fff');
          dispatch('asignarMonederoPropietario',ticket).then(() => {
            console.log("Datos propietario actualizado correctamente")
            db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id).
            collection(FS_COLLECTIONS.TICKETS).add(ticket).then(resp => {
              dispatch('actualizarUltimoIdTicket').then(() => {
                var salida = resp;
                salida.no_ticket = ticket.id_numerico;
                resolve(salida)
              })
            });
          })
        })
      } else {
        //Logica para guardar un ticket
        return new Promise((resolve, reject) => {
          console.log("Ticket no finaliza")
          console.log(ticket)
          ticket.id_numerico = getters.franquicia.id_ultimo_ticket;
          db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id).
          collection(FS_COLLECTIONS.TICKETS).add(ticket).then(resp => {
            dispatch('actualizarUltimoIdTicket').then(() => {
              var salida = resp;
              salida.no_ticket = ticket.id_numerico;
              resolve(salida)
            })
          })
        })
      }
    },
    guardaAnticipo({getters,dispatch},anticipo){
      var propietario = getters.propietarioActual;
      propietario.anticipos = anticipo;
      console.log("PROPIETARIO")
      console.log(propietario)
      dispatch('actualizarPropietario',propietario);
    },
    //Actualiza todos los servicios nuevos que se les relaciona un ticket
    actualizaTicketsPendientes({getters,dispatch},data){
      console.log("Se actualizará¡ tickets pendientes con store ticket")
      console.log(data);
      for(var i in data.servicios){
        let data_servicios = data.servicios[i];
        console.log("ID SERVICIO ANTES DE ACTUALIZAR")
        console.log(data_servicios.id_caso);
        console.log("ID TICKET A ACTUALIZAR")
        console.log(data.no_ticket);
            dispatch('cargaServicioCasoSeleccionado',data_servicios.id_caso).then(servicio =>{
              console.log("CARGA SERVICIO PARA ACTUALIZAR CON TICKET " + data.id)
              console.log("ID DEL SERVICIOCASO QUE SE ACTUALIZA " + data_servicios.id_caso)
              console.log(servicio)
              let servicio_l = servicio;
              servicio_l.ticket = data.id;
              servicio_l.no_ticket = data.no_ticket;
              db.collection(FS_COLLECTIONS.FRANQUICIAS)
              .doc(getters.franquicia.id)
              .collection("ServiciosCasos")
              .doc(data_servicios.id_caso)
              .update(servicio_l);
            });
      }
    },
    actualizaAnticiposPropietario({getters,dispatch}, pagos){
      //var pagos_propietario = getters.propietarioActual.anticipos;
      dispatch('cargaPropietario',getters.propietarioActual.id).then(prop => {
        var propietarioActual = prop;
        console.log("%cPROPIETARIO ANTICIPOS",'background: blue ; color: #fff');
        console.log(propietarioActual);
        console.log("Pagos hechos")
        console.log(pagos)
        var tiene_anticipos = false;
        for(var i in pagos){
          if(pagos[i].forma_pago=='Anticipos'){
            tiene_anticipos = true;
            for(var j in propietarioActual.anticipos){
              if(pagos[i].id == propietarioActual.anticipos[j].id){
                propietarioActual.anticipos[j].usado = true;
                if(propietarioActual.anticipos[j].monto!==pagos[i].monto){
                  propietarioActual.anticipos[j].monto = pagos[i].monto;
                }
              }
            }
          }
        }
        console.log("Propietario con anticipo")
        console.log(propietarioActual);
        if(tiene_anticipos){
          dispatch('actualizarPropietario',propietarioActual);
        }
      })
      
    },
    actualizaPagosPendientesPropietario({getters, dispatch}, pagos){
      var propietarioActual = getters.propietarioActual;
      console.log("Pagos hechos")
      console.log(pagos)
      for(var i in pagos){
        for(var j in propietarioActual.anticipos){
          if(pagos[i].id == propietarioActual.anticipos[j].id){
            propietarioActual.anticipos[j].usado = false;
          }
        }
      }
      console.log("Propietario con anticipo")
      console.log(propietarioActual);
      return new Promise((resolve,reject) => {
        dispatch('actualizarPropietario',propietarioActual).then(() => resolve()).catch(error => reject(error))
      })
    },
    cargaListaImpresoras({}){
      return new Promise((resolve, reject) => {
        axios
          .get('https://app.pixancloud.com/ws/ticket/buscarImpresora.php/')
          .then(response => {
            console.log("Respuesta impresoras")
            console.log(response);
            resolve(response)
          })
          .catch(error => {
            console.log('Error')
            console.log(error)
            reject(error)
          })
      })
    },
    
  }
}
export default store


// WEBPACK FOOTER //
// ./src/store/saldo/saldo.js